import { ApiProperty } from "@nestjs/swagger";

export class ConsumedItemsForSoReq{
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    storeConsumptionId:number[];
}